module.exports = {
  colors: {
    'base-darkest': '#00192F',
    'base-darker': '#00325E',
    'base-dark': '#004B8D',
    'primary-base': '#0064BC',
    // semantic: primary interactive/action color (steppers, primary buttons)
    interactive: '#007DEB',
    'base-medium-light': '#007DEB',
    'base-medium-lighter': '#3397EF',
    'base-normal-light': '#66B1F3',
    'base-normal-lighter': '#99CBF7',
    'base-very-light': '#CCE5FB',
    // not in design palette
    'base-lightest': '#E5F2FD',
    'base-muted': '#809BB2',

    'secondary-darkest': '#192111',
    'secondary-darker': '#324122',
    'secondary-dark': '#4B6232',
    secondary: '#648243',
    'secondary-medium-light': '#7DA354',
    'secondary-medium-lighter': '#97B576',
    'secondary-normal-light': '#B1C898',
    'secondary-normal-lighter': '#CBDABB',
    'secondary-very-light': '#E5EDDD',
    // not in design palette
    'secondary-lightest': '#F2F6EE',

    'tertiary-darkest': '#272520',
    'tertiary-darker': '#474239',
    'tertiary-dark': '#665F52',
    tertiary: '#857C6B',
    'tertiary-medium-light': '#A59A85',
    'tertiary-medium-lighter': '#C4B79E',
    'tertiary-normal-light': '#D4CAB8',
    'tertiary-normal-lighter': '#E3DDD2',
    'tertiary-very-light': '#F3F1EC',
    // not in design palette
    'tertiary-lightest': '#F9F7F3',

    'complimentary-darkest': '#12182B',
    'complimentary-darker': '#2A3864',
    'complimentary-dark': '#42589D',
    complimentary: '#5A78D6',
    'complimentary-medium-light': '#748EDD',
    'complimentary-medium-lighter': '#8FA3E3',
    'complimentary-normal-light': '#A9B9EA',
    'complimentary-normal-lighter': '#C4CEF0',
    'complimentary-very-light': '#DEE4FA',
    // not in design palette
    'complimentary-lightest': '#EFF2FD',

    'accent-darkest': '#1F132A',
    'accent-darker': '#472C62',
    'accent-dark': '#70469B',
    accent: '#995FD3',
    'accent-medium-light': '#A979DA',
    'accent-medium-lighter': '#BA92E1',
    'accent-normal-light': '#CAACE8',
    'accent-normal-lighter': '#DAC5EF',
    'accent-very-light': '#EBDFF6',
    // not in design palette
    'accent-lightest': '#F5EFFA',

    'neutral-darkest': '#1C1C1C',
    // semantic ticket-card text tokens (shared PriceCard) — TL values = current (no visual change)
    'card-title': '#1C1C1C',
    'card-desc': '#393939',
    'card-label': '#393939',
    'card-value': '#A5A5A5',
    'card-quantity': '#393939',
    'card-subtotal': '#A5A5A5', // = card-value
    'neutral-darker': '#393939',
    'neutral-dark': '#555555',
    neutral: '#727272',
    'neutral-medium-light': '#8E8E8E',
    'neutral-medium-lighter': '#A5A5A5',
    'neutral-normal-light': '#BBBBBB',
    'neutral-normal-lighter': '#D2D2D2',
    'neutral-very-light': '#E8E8E8',
    // not in design palette
    'neutral-lightest': '#F4F4F4',
    'neutral-ultra-lightest': '#FAFAFA',
    'neutral-background-profile': '#FAFAFA',

    'success-darkest': '#0E260E',
    'success-darker': '#1B4C1B',
    'success-dark': '#297329',
    success: '#369936',
    'success-medium-light': '#44BF44',
    'success-medium-lighter': '#69CC69',
    'success-normal-light': '#8FD98F',
    'success-normal-lighter': '#B4E5B4',
    'success-very-light': '#DAF2DA',
    // not in design palette
    'success-lightest': '#EDF9ED',

    'warning-darkest': '#332B05',
    'warning-darker': '#665709',
    'warning-dark': '#99820E',
    warning: '#CCAE12',
    'warning-medium-light': '#FFD917',
    'warning-medium-lighter': '#FFE145',
    'warning-normal-light': '#FFE874',
    'warning-normal-lighter': '#FFF0A2',
    'warning-very-light': '#FFF7D1',
    // not in design palette
    'warning-lightest': '#FFF3E8',

    'error-darkest': '#2D0A06',
    'error-darker': '#5A140C',
    'error-dark': '#861D11',
    error: '#B32717',
    'error-medium-light': '#E0311D',
    'error-medium-lighter': '#E65A4A',
    'error-normal-light': '#EC8377',
    'error-normal-lighter': '#F3ADA5',
    'error-very-light': '#F9D6D2',
    // not in design palette
    'error-lightest': '#FCEBE9',

    // not in design palette
    'frozen-ice': '#28B5F3',
    hazard: '#FF5A19', // adm
    'alert-dark': '#B42A2A', // adm
    'alert-base': '#D0021B', // adm
    'alert-lightest': '#FFF6F6', // adm

    'info-darkest': '#082431',
    'info-darker': '#104861',
    'info-dark': '#186D92',
    info: '#2091C2',
    'info-medium-light': '#28B5F3',
    'info-medium-lighter': '#53C4F5',
    'info-normal-light': '#7ED3F8',
    'info-normal-lighter': '#A9E1FA',
    'info-very-light': '#D4F0FD',
  },
  backgroundImage: {
    'custom-bg': "url('/tuuleliinid/images/bg_waves.jpg')",
  },
  backgroundPosition: {
    '20-center': '20% center',
  },
  backgroundSize: {
    cover: 'cover',
  },
  backgroundRepeat: {
    'no-repeat': 'no-repeat',
  },
  backgroundAttachment: {
    fixed: 'fixed',
  },
}
